import {Space, Steps} from "antd";
import {useCreateBundleContext} from "../../context/create-bundle";
import {CreateBundleSteps} from "../../reducers/create-bundle/types";

export function CreateBundleFormSteps() {
  const {state} = useCreateBundleContext();
  const mapStepToNumber: Record<CreateBundleSteps, number> = {
    basicForm: 0,
    checkoutForm: 1,
    coverImagesUpload: 2,
    automations: 3,
  };
  return (
    <div>
      <Steps
        current={mapStepToNumber[state.currentCreateBundleStep]}
        size="small"
        direction="vertical"
      >
        <Steps.Step title="Bundle information" />
        <Steps.Step
          title="Checkout form"
          disabled={state.currentCreateBundleStep === "basicForm"}
        />
        <Steps.Step
          title="Cover image upload"
          disabled={
            state.currentCreateBundleStep === "basicForm" ||
            state.currentCreateBundleStep === "checkoutForm"
          }
        />
        <Steps.Step
          title="Automations"
          disabled={
            state.currentCreateBundleStep === "basicForm" ||
            state.currentCreateBundleStep === "checkoutForm" ||
            state.currentCreateBundleStep === "coverImagesUpload"
          }
        />
      </Steps>
    </div>
  );
}

export function CreateSessionFormStepsMobile() {
  const {state} = useCreateBundleContext();
  const mapStepToNumber: Record<CreateBundleSteps, number> = {
    basicForm: 0,
    checkoutForm: 1,
    coverImagesUpload: 2,
    automations: 3,
  };
  const mapStepToTitle: Record<CreateBundleSteps, string> = {
    basicForm: "Bundle information",
    checkoutForm: "Checkout form",
    coverImagesUpload: "Cover image upload",
    automations: "Automations",
  };
  return (
    <Space size={16} align="center">
      <div
        style={{
          width: "2.4rem",
          height: "2.4rem",
          borderRadius: "3.2rem",
          backgroundColor: "#222222",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {mapStepToNumber[state.currentCreateBundleStep] + 1}
      </div>

      <p>{mapStepToTitle[state.currentCreateBundleStep]}</p>
    </Space>
  );
}
